import React, { useEffect, useState } from 'react';
import styles from './dashboardstyles';
import { useSelector } from 'react-redux';
import * as CaseType from '../../config/caseType';
import * as Status from '../../config/status';
import ApiConstants from '../../config/ApiConstants';
import {
  Box,
  Container,
  Typography,
  Avatar,
  Button,
  Link
  // Tooltip,
  // Fab,
  // IconButton
} from '@mui/material';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import EmailIcon from '@mui/icons-material/Email';
import * as caseActions from '../../actions/caseActions';
import { useDispatch } from 'react-redux';
//import List from '@mui/material/List';
//import ListItem from '@mui/material/ListItem';
//import ListItemAvatar from '@mui/material/ListItemAvatar';
//import ListItemIcon from '@mui/material/ListItemIcon';
//import ListItemText from '@mui/material/ListItemText';
//import IconButton from '@mui/material/IconButton';
//import FolderIcon from '@mui/icons-material/Folder';
//import DeleteIcon from '@mui/icons-material/Delete';
//import UploadedFilesTable from '../fileupload/uploadedfilestable';
const Summary = () => {
  console.log('Summary: - Summary section loading...');
  const st = useSelector((state) => state.rootReducer);
  const dispatch = useDispatch();

  const [currentcase, setCurrentcase] = useState(
    st.cases !== null && st.cases.length > 0 ? st.cases[0] : null
  );

  let contacts = null;
  if (st.contacts != null) {
    contacts = st.contacts;
  }
  useEffect(() => {
    console.log('Case id = ', st.caseId);
    var caseId = st.caseId;
    if (caseId === 0 && st.cases !== null && st.cases.length > 0) {
      caseId = st.cases[0].caseId;
      dispatch(caseActions.setCaseId(caseId));
    }
    if (st.cases !== undefined && st.cases.length > 0) {
      st.cases.find((c) => {
        // string to int compare
        if (c.caseId == caseId) {
          setCurrentcase(c);
          return;
        }
      });
    }
  }, [st.caseId, st.cases]);

  const getImage = (data, caseId, roleName) => {
    var imageLink = ApiConstants.BASE_IMAGE_URL + 'default.jpeg'; // support comma delimited roles
    Array.prototype.map.call(roleName.split(','), function (x) {
      var found = data.find((obj) => {
        return (
          obj.caseId === caseId &&
          obj.roleName === x &&
          obj.profileImage !== undefined &&
          obj.profileImage.trim() !== undefined &&
          obj.profileImage.trim().length !== 0
        );
      });
      if (found !== undefined) {
        return (imageLink = ApiConstants.BASE_IMAGE_URL + found.profileImage + '.jpeg');
      } else {
        return (imageLink = ApiConstants.BASE_IMAGE_URL + 'default.jpeg');
      }
    });
    return imageLink;
  };
  const isThisRoleAssigned = (data, caseId, roleName) => {
    var assigned = false;
    if (caseId === 0) return false;
    Array.prototype.map.call(roleName.split(','), function (x) {
      if (assigned) {
        return;
      }
      var found = data.find((obj) => {
        return (
          obj.caseId === caseId &&
          obj.roleName === x &&
          ((obj.firstName !== undefined &&
            obj.firstName.trim() !== undefined &&
            obj.firstName.trim().length !== 0) ||
            (obj.lastName !== undefined &&
              obj.lastName.trim() !== undefined &&
              obj.lastName.trim().length !== 0))
        );
      });
      if (found !== undefined) {
        assigned = true;
      }
    });
    return assigned;
  };
  const removeSecond = (dateString) => {
    var returnString = new Date(dateString).toLocaleTimeString().replace(/(.*)\D\d+/, '$1');
    return returnString;
  };

  const formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return match[1] + '-' + match[2] + '-' + match[3];
    }
    return null;
  };

  return (
    <Box>
      {currentcase !== null && (
        <Container>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              adjustItems: 'center',
              justifyContent: 'space-between',
              mt: 3
              // background: '#E2F3FF'
            }}>
            <Typography variant="h6">
              Case Info for{' '}
              {currentcase != null && currentcase !== undefined && currentcase.patientLastName},
              {currentcase != null && currentcase !== undefined && currentcase.patientFirstName}{' '}
              (MRN:
              {currentcase != null &&
              currentcase !== undefined &&
              currentcase.patientMRN !== undefined
                ? currentcase.patientMRN
                : 'N/A'}
              )
            </Typography>
          </Box>

          <Typography style={styles.titleText}>Summary</Typography>
          <Box
            sx={{
              display: 'flex',
              flex: 3,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%'
            }}>
            <Box sx={{ width: '45%' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  borderBottom: 1,
                  borderColor: 'grey.500'
                }}>
                <Typography style={styles.titleStyle}>Inquiry for</Typography>
                <Typography style={styles.titleStyle}>
                  {currentcase === null ? '' : CaseType.getText(currentcase.caseType)}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  borderBottom: 1,
                  borderColor: 'grey.500'
                }}>
                <Typography style={styles.titleStyle}>Inquiry received</Typography>
                <Typography style={styles.titleStyle}>
                  {currentcase !== null && new Date(currentcase.inquiryDate).toDateString()}{' '}
                  {currentcase !== null && removeSecond(currentcase.lastUpdateDate)}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ width: '45%' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  borderBottom: 1,
                  borderColor: 'grey.500'
                }}>
                <Typography style={styles.titleStyle}>Last updated</Typography>
                <Typography style={styles.titleStyle}>
                  {currentcase !== null && new Date(currentcase.lastUpdateDate).toDateString()}{' '}
                  {currentcase !== null && removeSecond(currentcase.lastUpdateDate)}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  borderBottom: 1,
                  borderColor: 'grey.500'
                }}>
                <Typography style={styles.titleStyle}>Inquiry status</Typography>
                <Typography style={styles.titleStyle}>
                  {currentcase === null ? '' : Status.getText(currentcase.status)}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Typography style={styles.titleText}>Contact us</Typography>
          {currentcase !== null && currentcase.status === Status.STATUS_NEW_UNASSIGNED && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }}>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginTop: 20
                }}>
                <Avatar
                  sx={{ width: 56, height: 56, mr: 3 }}
                  alt="Heart Opinion"
                  src={require('../../images/Logo.png')}
                />
                <Typography style={styles.nameStyle}>
                  Boston Children&apos;s Benderson Family Heart Center
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end'
                }}>
                <Button>
                  <PhoneInTalkIcon name="phone-outgoing" color="blue" style={{ fontSize: 20 }} />
                  <Typography style={styles.nameStyle}>1-844-354-2160</Typography>
                </Button>
                <Button>
                  <EmailIcon name="email-edit-outline" color="blue" style={{ fontSize: 20 }} />
                  <Typography style={styles.nameStyle}>Heart@childrens.harvard.edu</Typography>
                </Button>
              </Box>
            </Box>
          )}
          {currentcase !== null &&
            currentcase.status !== Status.STATUS_NEW_UNASSIGNED &&
            isThisRoleAssigned(
              contacts,
              currentcase === null ? 0 : currentcase.caseId,
              'Coordinator,Nurse Practitioner'
            ) && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%'
                }}>
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: 20,
                    marginBottom: 20
                  }}>
                  <Avatar
                    sx={{ width: 56, height: 56, mr: 3 }}
                    alt="Heart Opinion"
                    src={getImage(contacts, currentcase.caseId, 'Coordinator,Nurse Practitioner')}
                  />
                  <Box
                    style={{
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                    <Typography style={styles.nameStyle}>
                      {contacts.find((obj) => {
                        return (
                          obj.caseId === currentcase.caseId &&
                          (obj.roleName === 'Coordinator' || obj.roleName === 'Nurse Practitioner')
                        );
                      }) === undefined
                        ? ''
                        : contacts.find((obj) => {
                            return (
                              obj.caseId === currentcase.caseId &&
                              (obj.roleName === 'Coordinator' ||
                                obj.roleName === 'Nurse Practitioner')
                            );
                          }).firstName}{' '}
                      {contacts.find((obj) => {
                        return (
                          obj.caseId === currentcase.caseId &&
                          (obj.roleName === 'Coordinator' || obj.roleName === 'Nurse Practitioner')
                        );
                      }) === undefined
                        ? ''
                        : contacts.find((obj) => {
                            return (
                              obj.caseId === currentcase.caseId &&
                              (obj.roleName === 'Coordinator' ||
                                obj.roleName === 'Nurse Practitioner')
                            );
                          }).lastName}
                    </Typography>
                    <Typography style={styles.titleStyle}>
                      {contacts.find((obj) => {
                        return (
                          obj.caseId === currentcase.caseId &&
                          (obj.roleName === 'Coordinator' || obj.roleName === 'Nurse Practitioner')
                        );
                      }) === undefined
                        ? 'Coordinator'
                        : contacts.find((obj) => {
                            return (
                              obj.caseId === currentcase.caseId &&
                              (obj.roleName === 'Coordinator' ||
                                obj.roleName === 'Nurse Practitioner')
                            );
                          }).roleName}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end'
                  }}>
                  <Button>
                    <PhoneInTalkIcon name="phone-outgoing" color="blue" style={{ fontSize: 20 }} />
                    <Typography style={styles.nameStyle}>
                      {contacts.find((obj) => {
                        return (
                          obj.caseId === currentcase.caseId &&
                          (obj.roleName === 'Coordinator' || obj.roleName === 'Nurse Practitioner')
                        );
                      }) === undefined
                        ? '1-844-354-2160'
                        : formatPhoneNumber(
                            contacts.find((obj) => {
                              return (
                                obj.caseId === currentcase.caseId &&
                                (obj.roleName === 'Coordinator' ||
                                  obj.roleName === 'Nurse Practitioner')
                              );
                            }).phone
                          )}
                    </Typography>
                  </Button>
                  <Button>
                    <EmailIcon name="email-edit-outline" color="blue" style={{ fontSize: 20 }} />
                    <Typography style={styles.nameStyle}>
                      {contacts.find((obj) => {
                        return (
                          obj.caseId === currentcase.caseId &&
                          (obj.roleName === 'Coordinator' || obj.roleName === 'Nurse Practitioner')
                        );
                      }) === undefined
                        ? 'Heart@childrens.harvard.edu'
                        : contacts.find((obj) => {
                            return (
                              obj.caseId === currentcase.caseId &&
                              (obj.roleName === 'Coordinator' ||
                                obj.roleName === 'Nurse Practitioner')
                            );
                          }).email}
                    </Typography>
                  </Button>
                </Box>
              </Box>
            )}
          {isThisRoleAssigned(
            contacts,
            currentcase === null ? 0 : currentcase.caseId,
            'Cardiologist'
          ) && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }}>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginTop: 20,
                  marginBottom: 20
                }}>
                <Avatar
                  sx={{ width: 56, height: 56, mr: 3 }}
                  alt="Heart Opinion"
                  src={getImage(contacts, currentcase.caseId, 'Cardiologist')}
                />
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                  <Typography style={styles.nameStyle}>
                    {contacts.find((obj) => {
                      return obj.caseId === currentcase.caseId && obj.roleName === 'Cardiologist';
                    }) === undefined
                      ? ''
                      : contacts.find((obj) => {
                          return (
                            obj.caseId === currentcase.caseId && obj.roleName === 'Cardiologist'
                          );
                        }).firstName}{' '}
                    {contacts.find((obj) => {
                      return obj.caseId === currentcase.caseId && obj.roleName === 'Cardiologist';
                    }) === undefined
                      ? ''
                      : contacts.find((obj) => {
                          return (
                            obj.caseId === currentcase.caseId && obj.roleName === 'Cardiologist'
                          );
                        }).lastName}
                  </Typography>
                  <Typography style={styles.titleStyle}>Cardiologist</Typography>
                </Box>
              </Box>
              <Button>
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    contacts.find((obj) => {
                      return obj.caseId === currentcase.caseId && obj.roleName === 'Cardiologist';
                    }) === undefined
                      ? 'https://www.childrenshospital.org/centers-and-services/departments/cardiology/meet-our-team'
                      : contacts.find((obj) => {
                          return (
                            obj.caseId === currentcase.caseId && obj.roleName === 'Cardiologist'
                          );
                        }).profileURL
                  }>
                  <Typography style={styles.nameStyle}>View my page</Typography>
                </Link>
              </Button>
            </Box>
          )}
          {isThisRoleAssigned(
            contacts,
            currentcase === null ? 0 : currentcase.caseId,
            'Surgeon'
          ) && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }}>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginTop: 20,
                  marginBottom: 0
                }}>
                <Avatar
                  sx={{ width: 56, height: 56, mr: 3 }}
                  alt="Heart Opinion"
                  src={getImage(contacts, currentcase.caseId, 'Surgeon')}
                />
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                  <Typography style={styles.nameStyle}>
                    {contacts.find((obj) => {
                      return obj.caseId === currentcase.caseId && obj.roleName === 'Surgeon';
                    }) === undefined
                      ? ''
                      : contacts.find((obj) => {
                          return obj.caseId === currentcase.caseId && obj.roleName === 'Surgeon';
                        }).firstName}{' '}
                    {contacts.find((obj) => {
                      return obj.caseId === currentcase.caseId && obj.roleName === 'Surgeon';
                    }) === undefined
                      ? ''
                      : contacts.find((obj) => {
                          return obj.caseId === currentcase.caseId && obj.roleName === 'Surgeon';
                        }).lastName}
                  </Typography>
                  <Typography style={styles.titleStyle}>Surgeon</Typography>
                </Box>
              </Box>
              <Button>
                <Link
                  color="inherit"
                  href={
                    contacts.find((obj) => {
                      return obj.caseId === currentcase.caseId && obj.roleName === 'Surgeon';
                    }) === undefined
                      ? 'https://www.childrenshospital.org/centers-and-services/departments/cardiology/meet-our-team'
                      : contacts.find((obj) => {
                          return obj.caseId === currentcase.caseId && obj.roleName === 'Surgeon';
                        }).profileURL
                  }
                  target="_blank"
                  rel="noopener noreferrer">
                  <Typography style={styles.nameStyle}>View my page</Typography>
                </Link>
              </Button>
            </Box>
          )}
          <Box style={styles.messageContainer}>
            <Typography
              style={{
                color: '#021D4E',
                fontWeight: '800',
                fontSize: 18,
                textAlign: 'center'
              }}>
              Message for you
            </Typography>
            <Box sx={{ mt: 2, backgroundColor: '#EDF3FC' }}>
              <Typography
                style={{
                  color: '#021D4E',
                  fontWeight: '500',
                  fontSize: 16,
                  textAlign: 'center'
                }}>
                {currentcase !== null &&
                  currentcase.status === Status.STATUS_NEW_UNASSIGNED &&
                  Status.getMessages(currentcase.status, null, null)}
                {currentcase !== null &&
                  currentcase.status !== Status.STATUS_NEW_UNASSIGNED &&
                  Status.getMessages(
                    currentcase.status,
                    contacts.find((obj) => {
                      return (
                        obj.caseId === currentcase.caseId &&
                        (obj.roleName === 'Coordinator' || obj.roleName === 'Nurse Practitioner')
                      );
                    }) === undefined
                      ? '1-844-354-2160'
                      : formatPhoneNumber(
                          contacts.find((obj) => {
                            return (
                              obj.caseId === currentcase.caseId &&
                              (obj.roleName === 'Coordinator' ||
                                obj.roleName === 'Nurse Practitioner')
                            );
                          }).phone
                        ),
                    contacts.find((obj) => {
                      return (
                        obj.caseId === currentcase.caseId &&
                        (obj.roleName === 'Coordinator' || obj.roleName === 'Nurse Practitioner')
                      );
                    }) === undefined
                      ? 'Heart@childrens.harvard.edu'
                      : contacts.find((obj) => {
                          return (
                            obj.caseId === currentcase.caseId &&
                            (obj.roleName === 'Coordinator' ||
                              obj.roleName === 'Nurse Practitioner')
                          );
                        }).email
                  )}
              </Typography>
            </Box>
          </Box>
        </Container>
      )}
    </Box>
  );
};

export default Summary;
